// removed by extract-text-webpack-plugin
module.exports = {"errorInfo":"_2HKjkUa4rxfjGEW8t8bsq_"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ErrorLabel/ErrorLabel.scss
 ** module id = 961
 ** module chunks = 0
 **/